<template>
  <v-flex xs12 sm6 md3 mb-1>
    <v-card>
      <v-toolbar color="primary" dark card>
        <v-toolbar-title>{{title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout class="box-inner" align-center justify-center>
        <v-flex v-if="mainValue !== false" text-xs-center>
          <v-layout align-center justify-center column fill-height>
            <slot></slot>
          </v-layout>
        </v-flex>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="60"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'info-widget',
  props: ['mainValue', 'title'],
};
</script>

<style scoped>
  .box-inner{
    min-height: 200px;
  }
</style>
